export default __webpack_public_path__ + "static/media/benefit-3.4f50aea3.svg";